var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 671,
    height: 718,
    viewBox: "0 0 671 718",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.768 492.748C288.712 479.882 408.29 487.513 531.331 487.513C581.09 487.513 614.195 485.937 642.134 441.563C659.436 414.084 647.369 351.418 647.369 320.291C647.369 266.687 650.594 213.875 652.603 160.63C653.807 128.727 675.316 87.82 660.165 55.3524C643.656 19.9776 599.429 5.91272 563.612 5.91272C440.049 5.91272 315.607 14.6673 193.687 30.9234C169.537 34.1433 144.174 32.0867 119.818 32.0867C101.236 32.0867 83.1312 40.3712 64.5622 42.8471C37.4575 46.461 22.8829 95.2774 15.1225 117.007C-9.30349 185.399 19.722 261.057 24.4288 329.306C26.7597 363.104 40.1332 396.864 40.1332 432.257C40.1332 451.792 44.2414 468.361 45.368 487.513C47.204 518.726 158.672 503.218 186.707 503.218",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.177 382.817C206.798 411.682 277.062 407.766 296.638 398.522C307.689 393.303 322.077 382.971 330.664 374.384C340.264 364.784 338.278 351.275 344.914 371.185C354.211 399.074 384.184 398.522 410.64 398.522C442.952 398.522 443.67 374.278 458.916 351.409",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.359 220.539C173.515 220.539 187.439 252.192 218.116 262.417",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.533 262.417C171.189 242.227 183.514 223.051 197.177 204.835",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M396.099 199.6C401.224 225.226 435.549 234.195 443.212 257.183",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M390.864 257.183C399.593 236.233 443.539 209.906 464.151 199.6",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1943 142.017C21.9155 120.248 291.01 121.078 307.108 121.078C335.881 121.078 359.857 108.571 387.956 104.21C417.607 99.6095 447.347 100.139 477.238 100.139C500.96 100.139 513.826 144.619 540.347 152.196C561.778 158.319 593.304 152.487 615.96 152.487",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M191.942 712.609C207.63 666.97 218.163 622.062 225.677 574.469C226.837 567.125 157.072 589.993 144.829 605.296C134.322 618.43 132.345 616.496 155.298 621.873C190.612 630.144 231.76 631.169 265.229 644.557",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M333.281 576.505C295 583.465 256.963 638.601 292.566 670.731C321.165 696.539 354.407 695.751 381.557 663.169C395.346 646.623 428.926 581.875 399.007 566.035C381.543 556.79 357.662 560.8 338.516 560.8",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M526.968 691.67C526.968 652.253 532.203 613.139 532.203 574.178C532.203 558.588 527.569 560.667 513.59 569.234C493.821 581.351 472.293 595.251 453.681 609.077C444.526 615.877 414.414 627.718 425.762 628.852C451.215 631.398 478.099 628.852 503.702 628.852C518.347 628.852 588.833 630.758 595.02 618.383",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.6d3b9a22cd00eba6cd8e9574fa86eaa5.svg";
export { ForwardRef as ReactComponent };